<template>
	<el-dialog title="选择项目" :visible.sync="pjVisible" width="670px" :close-on-click-modal="false" center>
		<div class="pjdialog" v-if="pjData.length > 0">
			<div class="pjbox" v-for="item in pjData" :key="item.pr_Code">
				<svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiangmuguanli"></use></svg>
				<span class="pjtitle">{{ item.pr_Name || ' ' }}</span>
				<el-button @click="clkpj(item)">打开</el-button>
			</div>
		</div>
		<div v-else>暂未分配项目</div>
	</el-dialog>
</template>

<script>
import dial from './dial'
export default {
	name: 'project',
	data() {
		return {
			pjVisible: false,
			pjData: []
		};
	},
	mounted() {
		// this.loadData();
	},
	methods: {
		openProject() {
			this.loadData();
		},
		loadData() {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.ProjectUserList}`,
				data: {},
				cb(res) {
					if (res.result == '111111111111') {
						if (res.data.length != 0) {
							that.pjData = res.data;
							that.clkpj2(that.pjData[0]);
						}
						that.pjVisible = true;
					} else {
						that.pjData = [];
						// that.pjVisible = true;
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},
		clkpj(value) {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.getDialInfo}`,
				data: {
					prcode: value.pr_Code
				},
				cb(res) {
					if (res.result == '111111111111') {
						console.log(res.result);
						// that.$message.success('成功!');
						that.$store.state.pr_Code = value.pr_Code;
						that.$store.state.projectinfo = value;
						window.localStorage.setItem('prCode', value.pr_Code);
						let projectinfo = JSON.stringify(value);
						window.localStorage.setItem('projectinfo', projectinfo);
						that.pjVisible = false;
						console.log('111111111111111', res.data);
						let DialInfo = {
							dialtype: res.data.dialtype,
							APIServer: res.data.APIServer,
							dstid: res.data.dstid,
							clientid: res.data.clientid,
							def5: res.data.def5,
							def1: res.data.def1,
							def2: res.data.def2
						}
						window.localStorage.setItem('DialInfo', JSON.stringify(DialInfo));
						if(res.data.dialtype != 4) {
							console.log('1 :>> ', 1);
							// 非华旗国产化
							dialcontroller.init(res.data, 'stausDiv');
							$("#headerS").css("display", 'flex')
						} else {
							console.log('2 :>> ', 2);
							// 隐藏初始化状态文字
							$("#headerS").css("display", 'none')
						}

						/** 禁止修改拨打电话 */
						that.$store.state.forbid_up_phone = value.forbid_up_phone;
						window.localStorage.setItem('forbid_up_phone', value.forbid_up_phone);
						/** 隐藏电话 */
						that.$store.state.hide_phone = value.hide_phone;
						window.localStorage.setItem('hide_phone', value.hide_phone);
						/** 是否启用拨打控制 */
						that.$store.state.dial_control = value.dial_control;
						/** 最多拨打次数 */
						that.$store.state.most_dialnum = value.most_dialnum;
						//
						/** 是否修改扩展信息 */
						that.$store.state.alert_sample = value.alert_sample;
						window.localStorage.setItem('alert_sample', value.alert_sample);

						
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		},

		clkpj2(value) {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.getDialInfo}`,
				data: {
					prcode: value.pr_Code
				},
				cb(res) {
					if (res.result == '111111111111') {
						// console.log(res.result);
						// that.$message.success('成功!');
						that.$store.state.pr_Code = value.pr_Code;
						that.$store.state.projectinfo = value;
						window.localStorage.setItem('prCode', value.pr_Code);
						let projectinfo = JSON.stringify(value);
						window.localStorage.setItem('projectinfo', projectinfo);
						let DialInfo = {
							dialtype: res.data.dialtype,
							APIServer: res.data.APIServer,
							dstid: res.data.dstid,
							clientid: res.data.clientid,
							def5: res.data.def5,
							def1: res.data.def1,
							def2: res.data.def2
						}
						window.localStorage.setItem('DialInfo', JSON.stringify(DialInfo));
						if(res.data.dialtype != 4) {
							console.log('3 :>> ', 3);
							// 非华旗国产化
							$("#headerS").css("display", 'flex')
							dialcontroller.init(res.data, 'stausDiv');
							console.log(dialcontroller.help())
							if (dialcontroller.help()) {
								$('.stausHelp').css('display', 'block');
							}
						} else {
							console.log('4 :>> ', 4);
							// 隐藏初始化状态文字
							$("#headerS").css("display", 'none')
						}
						/** 禁止修改拨打电话 */
						that.$store.state.forbid_up_phone = value.forbid_up_phone;
						window.localStorage.setItem('forbid_up_phone', value.forbid_up_phone);
						/** 隐藏电话 */
						that.$store.state.hide_phone = value.hide_phone;
						window.localStorage.setItem('hide_phone', value.hide_phone);
						/** 是否启用拨打控制 */
						that.$store.state.dial_control = value.dial_control;
						/** 最多拨打次数 */
						that.$store.state.most_dialnum = value.most_dialnum;
						/** 是否修改扩展信息 */
						that.$store.state.alert_sample = value.alert_sample;
						window.localStorage.setItem('alert_sample', value.alert_sample);
					} else {
						that.$message.error(res.msg);
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>
<style type="text/css" lang="scss" scoped="scoped">
.pjdialog {
	max-height: 450px;
	overflow: auto;
	display: flex;
	flex-wrap: wrap;
	/deep/.el-dialog__header {
		border-bottom: 1px solid #0080ff;
	}
	.pjbox {
		width: 160px;
		height: 210px;
		margin-right: 26px;
		margin-bottom: 20px;
		border: solid 1px #ffffff;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		text-align: center;
		.icon {
			width: 54px;
			height: 54px;
			vertical-align: -0.15em;
			fill: currentColor;
			overflow: hidden;
			margin: 0px auto;
		}
		.pjtitle {
			font-size: 14px;
			color: #333333;
		}
	}
	.pjbox:hover {
		border: solid 1px #abdcff;
	}
}
</style>
